import React from 'react';
import { Bot, User } from 'lucide-react';
import tinycolor from 'tinycolor2';

function ChatMessage({
  message, isUser = false, isTyping = false, design = {}, languageCode = 'en',
}) {
  const bubbleBackground = isUser
    ? design.userResponseBackgroundColor || '#6366f1'
    : design.aiResponseBackgroundColor || '#ffffff';
  const bubbleText = readableOn(bubbleBackground);
  const iconColor = isUser ? design.userIconColor || '#6b7280' : design.aiIconColor || '#6366f1';
  const avatar = !isUser && design.avatar?.image;

  const icon = (
    <div
      className="flex h-9 w-9 flex-shrink-0 items-center justify-center overflow-hidden rounded-full shadow-md"
      style={{
        background: avatar ? 'none' : `linear-gradient(135deg, ${iconColor}, ${tinycolor(iconColor).darken(8).toHexString()})`,
        color: readableOn(iconColor),
      }}
    >
      {avatar && <img src={avatar} alt={design.avatar?.name || ''} className="h-full w-full object-cover" />}
      {!avatar && (isUser ? <User className="h-5 w-5" /> : <Bot className="h-5 w-5" />)}
    </div>
  );

  return (
    <div className={`flex items-end gap-3 ${isUser ? 'flex-row-reverse' : ''}`}>
      {icon}
      <div
        className="max-w-[80%] rounded-2xl px-5 py-3.5 shadow-md"
        style={{ backgroundColor: bubbleBackground, color: bubbleText }}
      >
        {isTyping ? (
          <div className="flex gap-2 py-1">
            {[0, 300, 600].map((delay) => (
              <div
                key={delay}
                className="h-2 w-2 animate-bounce rounded-full"
                style={{ backgroundColor: bubbleText, animationDelay: `${delay}ms` }}
              />
            ))}
          </div>
        ) : (
          <>
            <p className="text-[15px] leading-relaxed">{message.content}</p>
            {message.timestamp && (
              <div className={`mt-1 text-xs opacity-70 ${isUser ? 'text-right' : 'text-left'}`}>
                {formatTime(message.timestamp, languageCode)}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// Helpers

function readableOn(background) {
  return tinycolor.mostReadable(background, ['#111827', '#ffffff']).toHexString();
}

// the respondent's locale for the survey language, without touching the global moment locale
function formatTime(timestamp, languageCode) {
  try {
    return new Intl.DateTimeFormat(languageCode, { hour: 'numeric', minute: '2-digit' }).format(new Date(timestamp));
  } catch(err) {
    return new Date(timestamp).toLocaleTimeString();
  }
}

export default ChatMessage;
